import React, { useState } from 'react'
import Loader from '../components/Loader'
import Gradient from '../components/Gradient'
import Error from '../components/Error'
import Upload from '../components/upload/Upload'
import Connection from '../components/upload/Connection'
import { findSessionByCode, uploadPhoto } from '../api'
import { Helmet } from 'react-helmet'


function UploadPage() {
  const [session, setSession] = useState(false)
  const connect = async code => {
    await setSession(undefined)
    setSession(await findSessionByCode(code))
  }
  const upload = async photo => {
    setSession(await uploadPhoto(session.code, [photo]))
  }
  if (session === undefined)
    return <Loader />
  if (session.error)
    return <Error>{session.error}</Error>
  if (session)
    return <Upload upload={upload} session={session} />
  return <Connection connect={connect} />
}

export default function UploadWithGradient() {
  return (
    <div>
      <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/image-blob-reduce@4.1.0/dist/image-blob-reduce.min.js" type="text/javascript" />

      </Helmet>
      <style dangerouslySetInnerHTML={{ __html: `html { font-size: 130% }` }} />
      <Gradient />
      <UploadPage />
    </div>
  )
}